<template>
    <div
        :class="
            'mb-2 inline-block rounded  p-2 py-1 text-[14px] font-medium capitalize' +
            ' ' +
            postTagClass
        "
    >
        {{ postType }}
    </div>
</template>
<script>
export default {
    name: "resource-post-tag",
    props: {
        postType: {},
    },
    computed: {
        postTagClass() {
            let tagClasses = {
                article: "bg-purple-100 text-purple-200",
                video: "bg-primary-200 text-primary-600",
                podcast: "bg-green-100 text-green-300",
                worksheet: "bg-green-100 text-green-300",
            };

            return tagClasses[this.postType];
        },
    },
};
</script>
